import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ROLE_GVA_USER } from '../shared/constants';
import { DeclarationsAuthService } from './declarations-auth.service';

@Component({
  selector: 'ad-gva-user',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (isAuthorized) {
      <span><ng-content></ng-content></span>
    }
  `
})
export class GvaUserComponent implements OnInit {
  public isAuthorized!: boolean;

  constructor(private authService: DeclarationsAuthService) {}

  ngOnInit(): void {
    this.authService.hasRole$(ROLE_GVA_USER).subscribe((hasRole) => (this.isAuthorized = hasRole));
  }
}
